<script>

  import { version } from '~/../package.json';
  import { hash } from '../apps/imd/stores';

</script>

<div class="snippets">
  <div class="shade"></div>
  <div class="bits">
    <span>{$hash} · {version}</span>
    <span>powered by HyperIn</span>

  </div>
</div>

<style>
  .snippets {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    bottom: 0;

    color: #eee;
    font-size: 16px;
    text-shadow: 2px 2px rgba(0, 205, 155, .5);
  }

  .shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(transparent, rgba(0, 0, 0, .25));
    mix-blend-mode: multiply;
  }

  .bits {
    display: flex;
    justify-content: space-between;
    padding: 4px 8px;
  }

  .snippets span {
    mix-blend-mode: difference;
    opacity: .6;
    white-space: nowrap;
  }

  @media (min-width: 1920px) {
    .snippets {
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      background: transparent;
    }
  }
</style>